module.exports = __webpack_public_path__ + "img/10.2ac5c33f.jpg";